<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-clipboard-user"></i></div>
      <div>
        Liste des apprenants
        <div class="page-title-subheading">Gestion des livra apprenants</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
    <div class="d-flex justify-content-center">
        <div class="form-group">
            <label for="">Choisir la classe</label>
            <ng-select (change)="loadData2($event)">
                <ng-option *ngFor="let classroom of classrooms" [value]="classroom.id">{{classroom?.name}}</ng-option>
            </ng-select>
        </div>
    </div>


    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class=" " *ngIf="buttonsPermission">
                    <!-- <button *ngIf="role!='bvs'" class="btn btn-info btn-sm btn-label waves-effect waves-light  me-3" (click)="add(addContent)">Créer un livrable</button> -->
                  
                </div>
                <div class="card-body">
                      <div class="d-flex justify-content-between mb-5">
                       
    
                        <div class="form-group ms-auto">
                            <label for=""> <strong>Rechercher:</strong> </label>
                            <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                        </div>
                    </div>
    
                            <p>{{data!.length}} élément(s)</p>
                            <div class="table-responsive">
                            <table class="table" >
                                <thead class="">
                                    <tr>
                                        <th style="width: 10px;">#</th>
                                        <th>Apprenant</th>
                                        <th *ngFor="let ac of attendance_categories">{{ac}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'rooms' | paginate: {
                                    id:'ngxP1',
                                    itemsPerPage: pg.pageSize,
                                    currentPage: pg.p,
                                    totalItems: pg.total } ">
                                        <td>
                                            <div class="form-check mb-2">
                                                <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                            
                                            </div>
                                        </td>
                                        <td>{{d.identity}}</td>
                                        <td *ngFor="let ac of attendance_categories">
                                           0
                                        </td>
                                    </tr>
                                
                                </tbody>
                            </table>
                            </div>
                            <pagination-controls 
                            id="ngxP1"
                            (pageChange)="getPage($event)"
                          [maxSize]="9"
                          [directionLinks]="true"
                          [autoHide]="true"
                          [responsive]="true"
                          [previousLabel]="'Précédent'"
                          [nextLabel]="'Suivant'"
                          [screenReaderPaginationLabel]="'Pagination'"
                          [screenReaderPageLabel]="'page'"
                          [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                         </pagination-controls>
    
                </div><!-- end card -->
            </div>
            <!-- end col -->
        </div>
        <!-- end col -->
    </div>
    
    
    <ng-template #addContent let-c="close" let-d="dismiss">
        <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
        <div class="modal-header">
          <h6 class="modal-title" id="modal-basic-title">Générer un livrable pour l'apprenant</h6>
          <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body" >
            <div class="row mb-3" >
              
           
            </div>
           
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
        </div>
    </form>
      </ng-template>
    
      <ng-template #editContent let-c="close" let-d="dismiss">
        <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
        <div class="modal-header">
          <h6 class="modal-title" id="modal-basic-title">Modifier une demande de permission</h6>
          <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body" >
            <div class="row mb-3" >
          
                
             
            </div>
           
           
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
        </div>
    </form>
      </ng-template>

 
    